///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp = abcsetup.consumer_rfp || {};
abcsetup.consumer_rfp.review_rfi = abcsetup.consumer_rfp.review_rfi || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp.review_rfi = {
    init() {
        abcsetup.setTitle('Review Consumer RFP Event');

        abcsetup.consumer_rfp.show_rfi.init();
    }
}
